export default "__VITE_ASSET__CJk8LJQo__"